import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { SelectionChangedEvent, ColGroupDef, ColDef } from '@ag-grid-enterprise/all-modules';
import {
  XtpXdpConnection,
  XtpXdpConnectionProtocol,
} from 'data/xtp-xdp-connection/xtp-xdp-connection.types';
import CommonGrid from 'shared/commonGrid';
import { ROWSELECTION } from 'shared/commonGrid/grid-enums';
import ActionMenuCellRenderer from 'shared/commonGrid/action-menu-cell-renderer';
import XtpXdpGridActionMenu from '../XtpXdpGridActionMenu';

interface Props {
  data: XtpXdpConnectionProtocol[]
  selectedXtpXdpConnection: XtpXdpConnectionProtocol,
  hasPrivilegeToView: boolean
  hasPrivilegesToCreate: boolean
  hasPrivilegeToDelete: boolean
  noResults: boolean,
  beforeLogout: boolean,
  lastUpdatedAt: Date | undefined,
  columnDefs: (ColGroupDef | ColDef)[],
  autoGroupColumnDef: ColDef,
  onRefresh: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  onCreateNew: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  onSelectionChanged: (event: SelectionChangedEvent) => void
  onView: () => void;
  onEdit: () => void;
  onDelete: () => void;
}

const XtpXdpGrid: FunctionComponent<Props> = ({
  hasPrivilegesToCreate,
  hasPrivilegeToDelete,
  hasPrivilegeToView,
  data = [],
  noResults,
  beforeLogout,
  lastUpdatedAt,
  columnDefs,
  selectedXtpXdpConnection,
  autoGroupColumnDef,
  onCreateNew,
  onRefresh,
  onSelectionChanged,
  onView,
  onEdit,
  onDelete,
}: Props) => {
  const components = {
    actionMenuCellRenderer: ActionMenuCellRenderer,
  };
  const { t } = useTranslation();

  return (
    <div className="grid-container" style={{ height: 'inherit' }}>
      <CommonGrid
        createNewText={t('xtpXdpConnection.grid.newXdp')}
        pagination
        enableBrowserTooltips
        suppressAggFuncInHeader
        rowSelection={ROWSELECTION.SINGLE}
        hasPrivilegeToCreateNew={hasPrivilegesToCreate}
        hasPrivilegeToDelete={hasPrivilegeToDelete}
        hasPrivilegetoView={hasPrivilegeToView}
        rowData={data}
        noResults={noResults}
        isBeforeLogout={beforeLogout}
        columnDefs={columnDefs}
        autoGroupColumnDef={autoGroupColumnDef}
        components={components}
        lastUpdatedAt={lastUpdatedAt}
        handleCreateNew={onCreateNew}
        onRefresh={onRefresh}
        onSelectionChanged={onSelectionChanged}
        onActionMenuItemClick={onView}
      >
        <XtpXdpGridActionMenu
          selectedItem={selectedXtpXdpConnection}
          hasPrivilegesToCreate={hasPrivilegesToCreate}
          hasPrivilegeToDelete={hasPrivilegeToDelete}
          onEdit={onEdit}
          onDelete={onDelete}
        />

      </CommonGrid>
    </div>
  );
};

export default XtpXdpGrid;
